import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import { useStore } from "../../../app/stores/store";
import { Button, Header } from 'semantic-ui-react'
import { Formik, Form } from "formik";
import { Select } from 'semantic-ui-react';
import * as Yup from 'yup';
import { MySelectInput, MySelectInputEdicionesControl } from "../../../app/common/form/MySelectInput";
import { SaldosReportesFormValues } from "../../../app/models/SaldosReporte";
import './UsersList_style.css'
import { Message } from 'semantic-ui-react'
import MyTextInput from "../../../app/common/form/MyTextInput";
import XLSX from "xlsx";
import Swal from "sweetalert2";
import ReactExport from "react-export-excel";
import LoadingComponent from "../../../app/layout/LoadingComponent";
import { loadavg } from "os";
import { Link } from "react-router-dom";
import SubMenuOPReportes from "../../Operaciones/MenuOperaciones";
import Pagination from "react-bootstrap/Pagination";
import { Col, Container, Row } from "react-bootstrap";
import { Image } from 'semantic-ui-react'
import loginPlaceholder from '../../../../src/images/docente-placeholder.png';
import AdminUsuario from "./ModificarUsuario";
import { UserListBusqueda, UserListBusquedaFormValues } from "../../../app/models/UsersList";
import ModalEliminarUsuario from "../../../features/SGPersonas/form/ModalEliminarUsuario";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
let delegacioncurrent : any;
let permisos: any[] = [];

export default observer(function UsersList() {
    let items: any = [];
    const [currentPage, setCurrentPage] = useState(1);
    const [paginaInicial, setPaginaInicial] = useState(true)
    const [currentUser, setCurrentUser] = useState({id: "", nombre: "", cui: "", foto:"", email: ""})
   
   
    
   
    
    const [currentSearchCriteria, setCurrentSearchCriteria] = useState<UserListBusquedaFormValues | null>(null);
    const {
        userStore: { user, logout, isLoggedIn, roles }  
    } = useStore();
    
    const SuccesModal = () => {
        Swal.fire({
            position: "center",
            icon: "success",
            title: "Datos exportados",
            text: 'Los datos se han exportado correctamente',
            showConfirmButton: false,
            timer: 3500,
        });
    };

    const { UsersListStore, modalStore } = useStore();

    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [permiso, setPermiso] = useState([""]);
    
    useEffect(() => {
        
        roles()?.map((item: any) => { permisos.push(item) })
        setPermiso(permisos); 
        //console.log("ver permisos", permisos)
                       
    }, []);
     

    useEffect(() => {
        //console.log("ver permisos 21", permisos)

        if(permisos.includes ("Delegacion Norte")){
            delegacioncurrent = 2
         }else if (permisos.includes ("Delegacion Peten")){
            delegacioncurrent = 2
         }else{
            delegacioncurrent = 0
         }
         //console.log("ver delegacion", delegacioncurrent)
        if (isFirstLoad) {
            UsersListStore.ListaCompletaUsuarios(currentPage, delegacioncurrent);
            setIsFirstLoad(false);
        }
    }, [UsersListStore.ListaCompletaUsuarios, currentPage, isFirstLoad, delegacioncurrent]);
    
    const [filtroDelegacion, setFiltroDelegacion] = useState(delegacioncurrent); // 0 para "Todas"
    
    
    
    
    const validationSchema = Yup.object({
        keyword: Yup.string().required('Obligatorio'),
    })

    const [forceUpdate, setForceUpdate] = useState(0);

    function handleFormSubmit(criterio: UserListBusquedaFormValues) {
        setCurrentPage(1); 

        criterio.page = currentPage;
        
        setCurrentSearchCriteria(criterio); // Guarda el criterio de búsqueda
            
        // Si el filtroDelegacion es "Todas", no aplicar el filtro de delegación
        const delegacionFiltro = filtroDelegacion === 0 ? undefined : filtroDelegacion;
    
        UsersListStore.BuscarUsuario({ ...criterio});
        //console.log(UsersListStore.ReporteInscritosByCodigo);
    }
        

    const handlePageClick = (numberPagina: number) => { 
        setCurrentPage(numberPagina);
        const delegacionParaFiltrar = filtroDelegacion;
        if (currentSearchCriteria) {
            UsersListStore.BuscarUsuario({ ...currentSearchCriteria, page: numberPagina });
        } else {
            UsersListStore.ListaCompletaUsuarios(numberPagina, delegacionParaFiltrar);
        }
    };
    
       
    const neighbors = 2; // Número de páginas vecinas a la actual para mostrar
    const total_pages = UsersListStore.paginadorTotal;

    for (let number = 1; number <= total_pages; number++) {
        if (
            number === 1 ||
            number === total_pages ||
            (number >= currentPage - neighbors && number <= currentPage + neighbors)
        ) {
            items.push(
                <Pagination.Item key={number} activeLabel={""} onClick={() => {
                    handlePageClick(number);
                }} active={number === currentPage}>
                    {number}
                </Pagination.Item>,
            );
        } else if (
            (number === currentPage - neighbors - 1) ||
            (number === currentPage + neighbors + 1)
        ) {
            items.push(
                <Pagination.Item key={number} disabled>
                    ...
                </Pagination.Item>
            );
            // Saltar los números entre los puntos suspensivos
            if (number < currentPage) number = currentPage - neighbors - 1;
            else number = total_pages - 1;
        }
    }
    
    const [allUsersForExport, setAllUsersForExport] = useState<any[]>([]);

    const loadAllUsersForExport = async () => {
    let allUsers: any[] = [];
    let pageNumber = 1; // Empezamos con la página 1
    const maxPage = UsersListStore.paginadorTotal; // Usando total_pages de tu store

    //console.log(`Max pages to fetch: ${maxPage}`);
    const delegacionValue = 0; // Reemplaza "TuValorDeDelegacion" con el valor adecuado o null

    while (pageNumber <= maxPage) {
        //console.log(`Fetching users from page: ${pageNumber}`);
        
        const usersFromPage: any[] = await UsersListStore.ListaCompletaUsuarios(pageNumber, filtroDelegacion);
        
        //console.log(`Users from page ${pageNumber}:`, usersFromPage);

        // Verifica si usersFromPage es un array y no está vacío antes de agregarlo
        if (Array.isArray(usersFromPage) && usersFromPage.length > 0) {
            allUsers = [...allUsers, ...usersFromPage];
            pageNumber++; // Pasamos a la siguiente página
        } else {
            console.error("Received unexpected data format or empty array");
            break;
        }
    }
    
    //console.log("All users fetched:", allUsers);
    setAllUsersForExport(allUsers);
};

const handleHiddenExport = async () => {
    await loadAllUsersForExport();
    SuccesModal()
    // Don't show the success message here
    const hiddenExportButton = document.querySelector('.hidden_btn_exportar');
    
    if (hiddenExportButton instanceof HTMLElement) {
        // Crea un evento de clic
        const clickEvent = new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: true,
        });

        // Despacha el evento de clic en el botón
        hiddenExportButton.dispatchEvent(clickEvent);
    }
};


    const handleExportCurrentPage = () => {
        const hiddenExportButton = document.querySelector('.hidden_btn_exportar');

        if (hiddenExportButton instanceof HTMLElement) {
        // Crea un evento de clic
        const clickEvent = new MouseEvent('click', {
            view: window,
            bubbles: true,
            cancelable: true,
        });

        // Despacha el evento de clic en el botón
        hiddenExportButton.dispatchEvent(clickEvent);
    }
    };



    const headerCourseDiplo = () => {

        if(permiso.includes ("Delegacion Norte")){

          return (           
            <Select 
            placeholder="Seleccionar Delegación"
            options={[
               
                { key: "Delegación Regional Norte", value: 4, text: "Delegación Regional Norte" },
            ]}
            value={filtroDelegacion}
            onChange={(e, data) => {
                const selectedValue = data.value;
                //console.log(selectedValue);
                setFiltroDelegacion(selectedValue);
                setCurrentPage(1);
                UsersListStore.ListaCompletaUsuarios(1, selectedValue);
            }}
        />        
        )


        }else{

          return (
          
            <Select 
             placeholder="Seleccionar Delegación"
                 options={[
                                { key: "Central", value: 1, text: "Central" },
                                 { key: "Petén", value: 2, text: "Petén" },
                                 { key: "Todas", value: 0, text: "Todas" },
                                { key: "Delegación Regional Norte", value: 4, text: "Delegación Regional Norte" },
                         ]}
                                            value={filtroDelegacion}
                                            onChange={(e, data) => {
                                                const selectedValue = data.value;
                                                //console.log(selectedValue);
                                                setFiltroDelegacion(selectedValue);
                                                setCurrentPage(1);
                                                UsersListStore.ListaCompletaUsuarios(1, selectedValue);
                                            }}
                                        />
          
        )

        }
       
      };


    if(UsersListStore.loadingInitial == true) return <><LoadingComponent content="Cargando datos..." /></>

    if(paginaInicial == true){
        return (
            <>
                <div>
                    <div className="header_operaciones">
                        <h1>Administración de Usuarios</h1>
                    </div>
                    <br></br>
                    <br></br>
                    <h2>Ingrese su criterio de busqueda.</h2>
                    <h4>(Nombre o CUI)</h4>
                    <div className="buscar_operaciones">
                        <Formik validationSchema={validationSchema}
                            enableReinitialize
                            initialValues={{ keyword: "", page: 0 }}
                            onSubmit={values => handleFormSubmit(values)}>
                            {({ handleSubmit, isValid, isSubmitting, dirty }) => (
                                <Form className='ui form' onSubmit={handleSubmit} autoComplete='off'>
                                    <div className='form_buscar_operaciones'>
                                        <div>
                                            <MyTextInput id="keyword" name='keyword' placeholder='' />
                                        </div>
                                        <div className="boton_buscar_operaciones">
                                            <Button
                                                type='submit'
                                                content='Buscar'
                                                style={{ backgroundColor: "#15b3e8", color: "white" }}
                                            />
                                        </div>
                                        <div>

                                        {headerCourseDiplo()}

                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                        <br></br>
                        <Container className="convenios-section interior-solicitudes">
                            <Container className="convenio-head-list header_users_list">
                                <Col xs={3}  className="convenio-head-section">Nombre de usuario</Col>
                                <Col xs={2} className="convenio-head-section">CUI</Col>
                                <Col xs={3} className="convenio-head-section">Correo electrónico</Col>
                                <Col xs={1} className="convenio-head-section">Teléfono</Col>
                                <Col xs={2} className="convenio-head-section">Delegación</Col>
                                <Col  xs={1} className="convenio-head-section">
                                    Acciones
                                </Col>
                            </Container>
                            <Container className="convenio-body-list solicitudes-body-area">
                            {UsersListStore.ReporteInscritosByCodigo.map((item) => {
                                        if (!item.id || !item.fullName || !item.cui || !item.email) {
                                            // Si falta alguna información esencial, no renderizar el elemento
                                            return null;
                                        }
                                        return (
                                            <Row key={item.id} className="solicitudes-list filas_tabla">
                                            <Col xs={1}>
                                                <Image src={item.photo || loginPlaceholder} size='mini' circular />
                                            </Col>
                                            <Col xs={2}>{item.fullName}</Col>
                                            <Col xs={2} style={{textAlign:"center"}}>{item.cui}</Col>
                                            <Col xs={3} style={{textAlign:"center"}}>{item.email}</Col>
                                            <Col xs={1} style={{textAlign:"center"}}>{item.phone}</Col>
                                            <Col xs={2} style={{textAlign:"center"}}>{item.delegacion}</Col>
                                            <Col xs={1} className="acciones_area">
    
                                                <div className="contenedor_acciones">
                                                    <div className="contenedor_puntos">
                                                        <span className="more_users_list">...</span>
                                                    </div>
                                                    <div className="contenedor_botones">
                                                        <Button
                                                        className="circular-button edi-sol-but"
                                                        circular
                                                        color='twitter'
                                                        type="button"
                                                        icon={'pencil'}
                                                        onClick={() => {
                                                            UsersListStore.setPaginaInicial(false)
                                                            setPaginaInicial(false)
                                                            setCurrentUser({id: item.id, nombre: item.fullName, cui: item.cui, foto: item.photo, email: item.email})
                                                        }}
                                                        />
                                                        <Button
                                                        className="circular-button edi-sol-but"
                                                        circular
                                                        color='red'
                                                        type="button"
                                                        icon={'trash alternate'}
                                                        onClick={() => {
                                                            modalStore.openModal(<ModalEliminarUsuario usuario={item.id} />, "mini")
                                                        }}
                                                        />
                                                    </div>
    
                                                </div>
    
                                            </Col>
                                        </Row>
                                    
                                    )
                                
                                return null;
                                
                            })}
                            </Container>
                        </Container>
                        <Container className="pagination-lista-usuarios">
                                                    <Pagination>{items}</Pagination>
                                                </Container>
                                                <Container style={{ marginTop: "-50px" }}>
                            <button className="exportar_btn"                                
                                onClick={handleHiddenExport}
                                style={{ backgroundColor: "#15b3e8", color: "white" }}
                            >
                                Exportar
                            </button>
                            {/* Visible export button */}
                            <ExcelFile element={
                                <Button
                                    className="hidden_btn_exportar"
                                    type='submit'
                                    content='Exportar'
                                    style={{ backgroundColor: "#15b3e8", color: "white", display: "none" }}
                                />
                            }>
                                <ExcelSheet data={allUsersForExport} name="data">
                                    <ExcelColumn label="No." value="id" />
                                    <ExcelColumn label="DPI" value="cui" />
                                    <ExcelColumn label="Nombre Completo" value="fullName" />
                                    <ExcelColumn label="Correo Electrónico" value="email" />
                                    <ExcelColumn label="Celular" value="phone" />
                                    <ExcelColumn label="Delegación" value="delegacion" />
                                    <ExcelColumn label="Genero" value="genero"/>
                                    <ExcelColumn label="Identidad Cultural" value="identidadCultural"/>
                                    <ExcelColumn label="Comunidad Linguistica" value="comunidadLinguistica"/>
                                    <ExcelColumn label="Nacionalidad" value="nacionalidad"/>
                                    <ExcelColumn label="Departamento" value="reDepartamento"/>
                                    <ExcelColumn label="Municipio" value="reMunicipio"/>
                                    <ExcelColumn label="Grado Academico" value="proGradoAcademico"/>
                                    <ExcelColumn label="Profesion u Oficio" value="proProfesionUOficio"/>
                                    <ExcelColumn label="Entidad" value="labEntidad"/>
                                    <ExcelColumn label="Dependencia" value="labDependencia"/>
                                    <ExcelColumn label="Renglon" value="labRenglon"/>
                                    <ExcelColumn label="Empresa" value="labEmpresa"/>
                                    <ExcelColumn label="Fecha de creación" value="createdAt"/>
                                    <ExcelColumn label="Departamento donde trabaja" value="labDepartamento"/>
                                    <ExcelColumn label="Municipio donde trabaja" value="labMunicipio"/>
                                </ExcelSheet>
                            </ExcelFile>
                            <ExcelFile 
                                element={
                                    <Button
                                        id="quickExportButton"
                                        type='submit'
                                        content='Exportar Página Actual'
                                        style={{ backgroundColor: "#15b3e8", color: "white" }}
                                    />
                                }
                            >
                                <ExcelSheet data={UsersListStore.ReporteInscritosByCodigo} name="data">
                                    <ExcelColumn label="No." value="id" />
                                    <ExcelColumn label="DPI" value="cui" />
                                    <ExcelColumn label="Nombre Completo" value="fullName" />
                                    <ExcelColumn label="Correo Electrónico" value="email" />
                                    <ExcelColumn label="Celular" value="phone" />
                                    <ExcelColumn label="Delegación" value="delegacion" />
                                    <ExcelColumn label="Genero" value="genero"/>
                                    <ExcelColumn label="Identidad Cultural" value="identidadCultural"/>
                                    <ExcelColumn label="Comunidad Linguistica" value="comunidadLinguistica"/>
                                    <ExcelColumn label="Nacionalidad" value="nacionalidad"/>
                                    <ExcelColumn label="Departamento" value="reDepartamento"/>
                                    <ExcelColumn label="Municipio" value="reMunicipio"/>
                                    <ExcelColumn label="Grado Academico" value="proGradoAcademico"/>
                                    <ExcelColumn label="Profesion u Oficio" value="proProfesionUOficio"/>
                                    <ExcelColumn label="Entidad" value="labEntidad"/>
                                    <ExcelColumn label="Dependencia" value="labDependencia"/>
                                    <ExcelColumn label="Renglon" value="labRenglon"/>
                                    <ExcelColumn label="Empresa" value="labEmpresa"/>
                                    <ExcelColumn label="Fecha de creación" value="createdAt"/>
                                    <ExcelColumn label="Departamento donde trabaja" value="labDepartamento"/>
                                    <ExcelColumn label="Municipio donde trabaja" value="labMunicipio"/>
                                </ExcelSheet>
                            </ExcelFile>
                        </Container>
                    </div>
                </div>
            </>
        )
    }else{
        return (
            <div>
                <Button
                    type='submit'
                    content='Regresar'
                    onClick={() => {
                        setPaginaInicial(true)
                    }}
                    style={{ backgroundColor: "#15b3e8", color: "white" }}
                />
                <AdminUsuario id_usuario={currentUser.id} nombre_completo={currentUser.nombre} cui={currentUser.cui} foto={currentUser.foto} />
            </div>
        )
    }
    
})